import { useEffect, useState } from 'react';
import { Database, getUsername } from '../services/serviceDB';
import { getMontrealDate } from './GetISOlocalDate';
import { getId } from './GenerateID';

/**
 * Fetch all forms from the database 
 * and returns the content of the select form to the parents
 *
 * @param {function} childToParent callback function
 * @param {bool} isNewAllowed Create a new form
 * @param {bool} isArchivedAllowed Show archived forms (TODO)
 */
const FetchForms = ({childToParent}, isNewAllowed=false, isArchivedAllowed=false, forceRemote=false) => {

    const [formsDB, setFormsDB] = useState<any>({});
    const [formID, setFormID] = useState<any>({});

    useEffect(() => {
      let query = {selector: {}}
      if (isArchivedAllowed === false) {
        query = {
          selector: {
            is_archived: false
          }
        }
      }

      var FormDB = new Database("forms")
      let db: PouchDB.Database<{}>
      // Fetch infos from database 
      FormDB.local_database.info().then(function (result) {
        // Activate fetch to remote
        FormDB.fetchFromRemote()
        db = FormDB.local_database;
        // if no doc in local, display remote
        if(result.doc_count === 0) {
          db = FormDB.remote_database;
        }

        if(forceRemote) {
          db = FormDB.remote_database;
        }
      }).then(function (result) {
        db.find(query).then(async result => {
          // Create a new form if needed
          if (isNewAllowed) {
            let id = getId()
            setFormID(id)
            let newForm = {
                "form_content": {},
                "form_name": "Nouveau formulaire",
                "posted_at": getMontrealDate(),
                "posted_by": await getUsername(),
                "_id": id
            }
            let forms = result.docs
            // push the new form at the beginning of the array to let it appear first
            forms.unshift((newForm as any))
            setFormsDB(forms)
            childToParent(newForm)
          } else {
            // Default behaviour
            setFormsDB(result.docs)
            setFormID(result.docs[0]._id)
            // Send information to the parent using this component
            childToParent((result.docs[0] as any))
          }
        })
        .catch(err => console.log(err));
      })  
    }, [isNewAllowed, isArchivedAllowed])


    const handleChange = (event: { target: { value: any; }; }) => {
        const selectedValue = event.target.value;
        setFormID(selectedValue);
        // find the ID of the corresponding form
        const selectedRow = formsDB.find((row: any) => row._id === selectedValue);
        if (selectedRow) {
            // Send information to the parent using this component
            childToParent(selectedRow)
        }
      };


    return (
        <div className='fetch_form_container'>
        <h3><b>Séléctionner un formulaire</b></h3>
        <select className="select_fetched_forms" onChange={handleChange} value={formID}>
          {Object.keys(formsDB).map(key => (
            <option key={formsDB[key]._id} value={formsDB[key]._id}>
            {formsDB[key].form_name}
            </option> 
          ))}
        </select>
        </div>
    )
}

export default FetchForms